import type { SvgProps } from '../types';

export const ArrowRight = ({ size = 16, color = 'currentcolor' }: SvgProps) => (
  <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
    <path
      transform="translate(-4 -4)"
      fill={color}
      fillRule="evenodd"
      d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
    />
  </svg>
);
